import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { DxGridDataType } from "../../dx-grid-data-type";
/**
 * Тип данных колонки грида.
 * Объект создан больше для гуппировки полей, связанных с типизацией колонки и ее рендерингом. Чтобы не было огромной
 * и запутанной портянки в `DxGridColumn`.
 *
 * Объект один на все типы из-за ограничения десериализации. В классе `DxGridColumn` поле `dataType` имеет тип
 * `DxGridColumnDataType`, поэтому потомок без указания дополнительной информации будет десериализовываться как
 * базовый тип. Это можно победить добавление в JSON `__type: <Класс потомка>`. Но это лишние сложности с точки
 * зрения конфигурации.
 */
let DxGridColumnDataType = class DxGridColumnDataType {
    /**
     * Тип данных колонки грида.
     * Объект создан больше для гуппировки полей, связанных с типизацией колонки и ее рендерингом. Чтобы не было огромной
     * и запутанной портянки в `DxGridColumn`.
     *
     * Объект один на все типы из-за ограничения десериализации. В классе `DxGridColumn` поле `dataType` имеет тип
     * `DxGridColumnDataType`, поэтому потомок без указания дополнительной информации будет десериализовываться как
     * базовый тип. Это можно победить добавление в JSON `__type: <Класс потомка>`. Но это лишние сложности с точки
     * зрения конфигурации.
     */
    constructor() {
        /** Идент типа данных. По умолчанию строка. */
        this._typeIdent = DxGridDataType.TEXT;
        /** признак того, что ссылка на документ. Нужен, чтобы можно было открывать файлы минуя роутер */
        this._linkToDoc = false;
        /** Открывать ссылку в новом окне или нет */
        this._newWindow = false;
        /** Количество типов после запятой для типов CURRENCY и DOUBLE. */
        this._accuracy = 2;
        /** подсвечивать отрицательные значения для типа CURRENCY */
        this._highlightNegatives = false;
    }
    get isText() {
        return DxGridDataType.TEXT === this._typeIdent;
    }
    get isLargeText() {
        return DxGridDataType.LARGE_TEXT === this._typeIdent;
    }
    get isInt() {
        return DxGridDataType.INT === this._typeIdent;
    }
    get isDouble() {
        return DxGridDataType.DOUBLE === this._typeIdent;
    }
    get isCurrency() {
        return DxGridDataType.CURRENCY === this._typeIdent;
    }
    get isDictionary() {
        return DxGridDataType.DICTIONARY === this._typeIdent;
    }
    get isDate() {
        return DxGridDataType.DATE === this._typeIdent;
    }
    get isTime() {
        return DxGridDataType.TIME === this._typeIdent;
    }
    get isDateTime() {
        return DxGridDataType.DATE_TIME === this._typeIdent;
    }
    get isLink() {
        return DxGridDataType.LINK === this._typeIdent;
    }
    get isCheckbox() {
        return DxGridDataType.CHECKBOX === this._typeIdent;
    }
    get typeIdent() {
        return this._typeIdent;
    }
    set typeIdent(value) {
        this._typeIdent = value;
    }
    get format() {
        return this._format;
    }
    set format(value) {
        this._format = value;
    }
    get linkIcon() {
        return this._linkIcon;
    }
    set linkIcon(value) {
        this._linkIcon = value;
    }
    get linkPattern() {
        return this._linkPattern;
    }
    set linkPattern(value) {
        this._linkPattern = value;
    }
    get linkParams() {
        return this._linkParams;
    }
    set linkParams(value) {
        this._linkParams = value;
    }
    get dictIdent() {
        return this._dictIdent;
    }
    set dictIdent(value) {
        this._dictIdent = value;
    }
    get accuracy() {
        return this._accuracy;
    }
    get newWindow() {
        return this._newWindow;
    }
    set newWindow(value) {
        this._newWindow = value;
    }
    get linkToDoc() {
        return this._linkToDoc;
    }
    set linkToDoc(value) {
        this._linkToDoc = value;
    }
    get highlightNegatives() {
        return this._highlightNegatives;
    }
    set highlightNegatives(value) {
        this._highlightNegatives = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "typeIdent", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumnDataType.prototype, "_typeIdent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "format", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumnDataType.prototype, "_format", void 0);
tslib_1.__decorate([
    jsonMember({ name: "linkIcon", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumnDataType.prototype, "_linkIcon", void 0);
tslib_1.__decorate([
    jsonMember({ name: "linkPattern", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumnDataType.prototype, "_linkPattern", void 0);
tslib_1.__decorate([
    jsonMember({ name: "linkToDoc", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumnDataType.prototype, "_linkToDoc", void 0);
tslib_1.__decorate([
    jsonMember({ name: "newWindow", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumnDataType.prototype, "_newWindow", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: "linkParams", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxGridColumnDataType.prototype, "_linkParams", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dictIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumnDataType.prototype, "_dictIdent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "accuracy", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxGridColumnDataType.prototype, "_accuracy", void 0);
tslib_1.__decorate([
    jsonMember({ name: "highlightNegatives", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumnDataType.prototype, "_highlightNegatives", void 0);
DxGridColumnDataType = tslib_1.__decorate([
    jsonObject
], DxGridColumnDataType);
export { DxGridColumnDataType };
